import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const MoneyIcon = ({ color = '#9BA8AC', size = 24, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 28 28"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14 0a14 14 0 1 0 0 27.999A14 14 0 0 0 14 0Zm3.23 12.923A1.077 1.077 0 0 1 18.309 14v4.308a1.077 1.077 0 0 1-1.077 1.077h-2.154v1.077a1.077 1.077 0 0 1-2.154 0v-1.077H10.77a1.077 1.077 0 0 1 0-2.154h5.385v-2.154h-5.385A1.077 1.077 0 0 1 9.692 14V9.692a1.077 1.077 0 0 1 1.077-1.077h2.154V7.538a1.077 1.077 0 0 1 2.154 0v1.077h2.154a1.077 1.077 0 0 1 0 2.154h-5.385v2.154h5.385Z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

MoneyIcon.propTypes = propTypes;

export default MoneyIcon;
